import React from 'react';
import Moment from 'moment';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import './FlightDates.css';

const DayMonthFormat = 'D MMM';
const WeekDayFormat = 'ddd, ';
const DateFormat = 'DD/MM/YYYY';

const propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  date: PropTypes.string.isRequired
};

const defaultProps = {
  id: 'flightDates',
  date: Moment().toISOString()
};

class FlightDates extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dates: this.generateDates(this.props.date),
      mobileMainDateIndex: Number(3)
    };

    this.handleClick = this.handleClick.bind(this);
    this.incrementMobileMainDateIndex = this.incrementMobileMainDateIndex.bind(this);
    this.decrementMobileMainDateIndex = this.decrementMobileMainDateIndex.bind(this);
    this.getNextDate = this.getNextDate.bind(this);
    this.getPreviousDate = this.getPreviousDate.bind(this);
    this.getMainDate = this.getMainDate.bind(this);
    this.generateDates = this.generateDates.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dates: this.generateDates(nextProps.date),
      mobileMainDateIndex: Number(3)
    });
  }

  shouldComponentUpdate(nextProps) {
    return this.props.date !== nextProps.date;
  }

  handleClick(value) {
    if (this.props.onClick) {
      this.props.onClick(value);
    }
  }

  incrementMobileMainDateIndex() {
    this.handleClick(this.getNextDate());
  }

  decrementMobileMainDateIndex() {
    this.handleClick(this.getPreviousDate());
  }

  generateDates(date) {
    const dates = [];
    for (let i = -3; i < 4; i++) {
      const generatedDate = Moment(date, DateFormat)
        .add(i, 'days')
        .toISOString();
      dates.push(generatedDate);
    }
    return dates;
  }

  getNextDate() {
    return this.state.dates[this.state.mobileMainDateIndex + 1];
  }

  getPreviousDate() {
    return this.state.dates[this.state.mobileMainDateIndex - 1];
  }

  getMainDate() {
    return this.state.dates[this.state.mobileMainDateIndex];
  }

  render() {
    return (
      <Row id={`componentFlightDates-${this.props.id}`} className="flightDatesExternalRow">
        <Col xsHidden>
          <Row className="flightDatesRow">
            {this.state.dates.map((value, key) => (
              <Col
                md={key === 0 || key === 6 ? 1 : 2}
                key={key}
                className={`flightDatesItem ${
                  Moment(value).format(DateFormat) === this.props.date ? 'mainDate' : ''
                }`}>
                <span
                  id={`id-flight-dates-${key}`}
                  onClick={() => this.handleClick(value)}
                  ref={`flight-dates-${key}`}>
                  <span className="weekday">{Moment(value).format(WeekDayFormat)}</span>
                  <span className="dayMonth">{Moment(value).format(DayMonthFormat)}</span>
                </span>
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={2} mdOffset={5} className="flightDatesBottomBar" />
          </Row>
        </Col>

        <Col smHidden mdHidden lgHidden>
          <Row className="flightDatesRow">
            <Col xs={1} className="no-padding">
              <span
                id="flight-date-arrow-left"
                onClick={this.decrementMobileMainDateIndex}
                className="arrow-left"
              />
            </Col>
            <Col xs={3} className="flightDatesItem">
              <span
                id={`id-flight-dates-0`}
                onClick={() => this.handleClick(this.getPreviousDate())}>
                <span className="dayMonth">
                  {Moment(this.getPreviousDate()).format(DayMonthFormat)}
                </span>
              </span>
            </Col>
            <Col xs={4} className="flightDatesItem mainDate">
              <span id={`id-flight-dates-1`} onClick={() => this.handleClick(this.getMainDate())}>
                <span className="weekday">{Moment(this.getMainDate()).format(WeekDayFormat)}</span>
                <span className="dayMonth">
                  {Moment(this.getMainDate()).format(DayMonthFormat)}
                </span>
              </span>
            </Col>
            <Col xs={3} className="flightDatesItem">
              <span id={`id-flight-dates-2`} onClick={() => this.handleClick(this.getNextDate())}>
                <span className="dayMonth">
                  {Moment(this.getNextDate()).format(DayMonthFormat)}
                </span>
              </span>
            </Col>
            <Col xs={1} className="no-padding">
              <span
                id="flight-date-arrow-right"
                onClick={this.incrementMobileMainDateIndex}
                className="arrow-right"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={4} xsOffset={4} className="flightDatesBottomBar" />
          </Row>
        </Col>
      </Row>
    );
  }
}

FlightDates.propTypes = propTypes;
FlightDates.defaultProps = defaultProps;

export default FlightDates;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightDates/FlightDates.jsx